<template>
  <div
    class="top-safe-area"
    :style="{
      width: '100%',
      height: `${topSafeH ? topSafeH + 'px' : null}`,
      'background-color': backgroundColor,
    }"
  ></div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import useSystemStore from '~~/store/system'
const systemStoreData = useSystemStore()
const { $bt } = useNuxtApp()

defineProps({
  backgroundColor: {
    type: String,
    default: () => 'rgba(255, 255, 255, 0)',
  },
})

// data
const topSafeH = ref(0)

// init

onMounted(() => {
  const systemInfo = $bt.call.getSysInfo<null[], { safeTop: number }>()
  topSafeH.value = (systemInfo && systemInfo?.safeTop) || systemStoreData.info.safeTop || 0
})
</script>
<style lang="less" scoped></style>
